import { Howl } from 'howler';
import { InjectionKey } from 'vue';

type AudioItem = {
  loop: boolean;
  path: { mpeg: string; wav: string };
}

interface AudioConfig {
  confirm: AudioItem;
  close: AudioItem;
  toast: AudioItem;
  bigPopup: AudioItem;
  normalPopup: AudioItem;
  popup: AudioItem;
  click: AudioItem;
  bgm: AudioItem;
}

const { CDN } = process.env;
const generalAudioCDN = 'https://dl.dir.freefiremobile.com/common/web_event/tweb-event/FFSH/assets-common'
const getAudioUrl = (filename: string, cdn = generalAudioCDN) => `${cdn}/audios/${filename}`;

const audioConfigs: AudioConfig = {
  // common audio
  confirm: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_Confirm.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_Confirm.wav"),
    },
  },
  close: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_Close.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_Close.wav"),
    },
  },
  toast: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_Toast.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_Toast.wav"),
    },
  },
  bigPopup: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_BigPopUp.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_BigPopUp.wav"),
    },
  },
  normalPopup: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_NormalPopUp.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_NormalPopUp.wav"),
    },
  },
  popup: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_PopUp.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_PopUp.wav"),
    },
  },
  click: {
    loop: false,
    path: {
      mpeg: getAudioUrl("FF_SFX_WebEvent_UI_Click.mp3"),
      wav: getAudioUrl("FF_SFX_WebEvent_UI_Click.wav"),
    },
  },
  // game audio
  bgm: {
    loop: true,
    path: {
      mpeg: getAudioUrl("FF_BGM_BlockmanCarnival.mp3", CDN),
      wav: getAudioUrl("FF_BGM_BlockmanCarnival.wav", CDN),
    },
  },
};

type Audio = {
  [key: string]: Howl;
}

const audio: Audio =
  Object.entries(audioConfigs).reduce((acc, [audioKey, audioConfig]) => {
    return {
      ...acc,
      [audioKey]: new Howl({
        loop: audioConfig.loop,
        src: [audioConfig.path.mpeg, audioConfig.path.wav]
      })
    }
  }, {});

export const $audio: InjectionKey<Audio> = Symbol('audio');
export default audio;
